import React, { useState } from 'react';
import Sidebar from '../../components/Onboarding/Sidebar';
import StepContent from '../../components/Onboarding/StepContent';

const Onboarding= () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [companyId, setCompanyId] = useState(null);
 return (
      <div className="d-flex min-vh-100">
        <Sidebar currentStep={currentStep} onStepChange={setCurrentStep} />
        <main className="flex-grow-1 bg-white ">
          <StepContent step={currentStep} companyId={companyId} onCompanyCreated={setCompanyId} />
        </main>
      </div>
    );
  
};

export default Onboarding;